import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { ManualLookupRequestV2 } from "./shared/ManualLookupRequestV2";
import { DataService_MultiStationManualLookupV2 } from "./shared/data.service";

@Component({
	selector: "app-multi-station-manual-lookup-su",
	templateUrl: "./multi-station-manual-lookup-su.component.html",
	styleUrls: ["./multi-station-manual-lookup-su.component.css"],
})
export class MultiStationManualLookupSuComponent implements OnInit {
	constructor(private dataService: DataService_MultiStationManualLookupV2) {}

	ngOnInit(): void {}

	///////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////

	FirstName: string = "Debra";
	LastName: string = "Williams";
	Alias: string = "BRANNON NEAL DURAN";
	BirthDate: Date = new Date("09-30-1999");
	BirthYear: string = "1980";
	Lat: string = "39.9624300557864";
	Lon: string = "-76.7277124825486";
	Distance: string = "5mi";
	ZipCode: string = "17402";

	UseFirst: boolean = true;
	UseLast: boolean = true;
	UseAlias: boolean = false;
	UseBirthDate: boolean = false;
	UseBirthYear: boolean = true;
	UseLatLonDistance: boolean = false;
	UseZipCode: boolean = false;

	ManualQuery: string = "";
	EnterManually: boolean = false;

	OffenderLoading: boolean = false;

	lstOffenders: any = [];
	sortField: string;
	sortOrder: number;
	sortOptions: any = [
		{ label: "Date of Birth Newest to Oldest", value: "!DOB" },
		{ label: "Date of Birth Oldest to Newest", value: "DOB" },
		{ label: "Offender Status A to Z", value: "OffenderStatus" },
		{ label: "Offender Status Z to A", value: "!OffenderStatus" },
		{ label: "State A to Z", value: "State" },
		{ label: "State Z to A", value: "!State" },
		{ label: "Conviction Place A to Z", value: "ConvictionPlace" },
		{ label: "Conviction Place Z to A", value: "!ConvictionPlace" },
		{ label: "Race A to Z", value: "Race" },
		{ label: "Race Z to A", value: "!Race" },
		{ label: "Sex A to Z", value: "Sex" },
		{ label: "Sex Z to A", value: "!Sex" },
		{ label: "Height High to Low", value: "!Height" },
		{ label: "Height Low to High", value: "Height" },
		{ label: "Weight High to Low", value: "!Weight" },
		{ label: "Weight Low to High", value: "Weight" },
		{ label: "Hair Color A to Z", value: "HairColor" },
		{ label: "Hair Color Z to A", value: "!HairColor" },
		{ label: "Eye Color A to Z", value: "EyeColor" },
		{ label: "Eye Color Z to A", value: "!EyeColor" },
	];

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////

	onSearch() {
		var parms: ManualLookupRequestV2 = {
			Query: this.GetQueryPreview(),
		};

		this.OffenderLoading = true;

		var result = this.dataService.ManualOffenderLookupV2(parms);
		result.subscribe(
			(response) => {
				this.lstOffenders = response;

				this.onSortChange(this.sortOptions[0]);

				this.OffenderLoading = false;
			},
			(error) => {
				this.OffenderLoading = false;
			}
		);
	}

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////

	onSortChange(val) {
		let value = val.value;

		if (value.indexOf("!") === 0) {
			this.sortOrder = -1;
			this.sortField = value.substring(1, value.length);
		} else {
			this.sortOrder = 1;
			this.sortField = value;
		}
	}

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////

	IsLoading() {
		return this.OffenderLoading == true;
	}

	GetQueryPreview() {
		if (this.EnterManually == true) {
			return this.ManualQuery;
		} else {
			var ans = "";

			var lstOptions = [];
			if (this.UseFirst == true) {
				lstOptions = [...lstOptions, "first_name=" + this.FirstName];
			}
			if (this.UseLast == true) {
				lstOptions = [...lstOptions, "last_name=" + this.LastName];
			}
			if (this.UseAlias == true) {
				lstOptions = [...lstOptions, "alias=" + this.Alias];
			}
			if (this.UseBirthDate == true) {
				lstOptions = [...lstOptions, "birthdate=" + moment(this.BirthDate).format("YYYY-MM-DD")];
			}
			if (this.UseBirthYear == true) {
				lstOptions = [...lstOptions, "birthdate_year=" + this.BirthYear];
			}
			if (this.UseLatLonDistance == true) {
				lstOptions = [...lstOptions, "lat=" + this.Lat];
				lstOptions = [...lstOptions, "lon=" + this.Lon];
				lstOptions = [...lstOptions, "distance=" + this.Distance];
			}
			if (this.UseZipCode == true) {
				lstOptions = [...lstOptions, "zipcode=" + this.ZipCode];
			}

			ans += "?";

			for (var z = 0; z < lstOptions.length; z++) {
				var next = lstOptions[z];
				ans += next;

				if (z < lstOptions.length - 1) {
					ans += "&";
				}
			}

			return ans;
		}
	}

	///////////////////////////////////////////////////
}
